export default "__VITE_ASSET__YL4wcQdF__"